<template>
  <div class="referred">
    <v-card-text>
      <v-row>
        <v-text-field
          label="توضیحات"
          v-model="summary"
          outlined
        ></v-text-field>
      </v-row>

      <v-row>
        <v-switch
          v-model="necessary"
          label="ارسال پیامک"
          :checked.sync = "necessary"
        ></v-switch>
      </v-row>
      زمان یادآوری
      <v-row class="report-date-picker">
        <div class="col-6">
          <label class="from">تاریخ</label>
          <date-picker v-model="start_date"></date-picker>
        </div>
        <div class="col-6">
          <label class="to">ساعت</label>
          <date-picker type="time" v-model="start_time"></date-picker>
        </div>
      </v-row>
      <v-card-text>
        <treeselect
          :multiple="false"
          :load-options="load_users"
          :normalizer="normalizer_requests"
          :async="true"
@select="select_search_user"
          placeholder="جستجو کاربر برای ارجاع"
          v-model="user_model"
        />

      </v-card-text>
      لیست کاربران انتخاب شده
      <div class="chat-list" v-for="item in selected_users_items" :key="item.Id">
        <div class="chat-prev" v-on:click="goToDetail(item)">
          <v-card>
            <div class="flex-no-wrap justify-space-between">
              <div>
                <v-card-title
                  class="headline"
                  v-text="item.UserName"
                ></v-card-title>
              </div>

            </div>
          </v-card>

        </div>

      </div>
      <v-btn color="primary m-0" class="btn-end" v-on:click="save()">
        ثبت
      </v-btn>
    </v-card-text>
  </div>

</template>
<script>
  import InfiniteLoading from 'vue-infinite-loading'

  import Treeselect, {ASYNC_SEARCH} from '@riophae/vue-treeselect'
  // import the styles
  import '@riophae/vue-treeselect/dist/vue-treeselect.css'
  import moment from 'moment-jalaali'

  import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

  import {bus} from '../../main'
  import {longClickDirective} from 'vue-long-click'
  import Vue from 'vue'
  import mapboxgl from "mapbox-gl";

  const longClickInstance = longClickDirective({delay: 500, interval: 5000})
  Vue.directive('longclick', longClickInstance)
  const simulateAsyncOperation = fn => {
    setTimeout(fn, 200)
  }

  export default {
    props: [
      'passing_data'
    ],

    data() {
      return {
        selected_users_items: [],
        users_items: [],
        descriptionLimit: 60,
        entries: [],
        isLoading: false,
        user_model: null,
        search: null,

        title:"",
        summary:"",
        necessary:false,
        start_date:"",
        start_time:"",

        active_tab: 0,
        product_info_dialog: false,
        selected_product_info: {},
        list: [],
        errors: [],
        post_items: [],
        selected_post: 0,
        dialog_factor: false,
        enable_finalize: false,
        selected_branch: 0,
        request_items: [],
        last_request_items: [],
        show_loading: false,
        page: 0,
        request_summary: '',
        selected_request: null,
        selected_user: null,
        disable_click: false,
        category_items: [],
        selected_category: 0,
        normalizer_requests(node) {
          return {
            id: node.Id,
            label: node.UserName,
          }
        },
        normalizer_persons(node) {
          return {
            id: node.Id,
            label: node.UserName,
          }
        },
        first: true,
      }
    },
    components: {
      datePicker: VuePersianDatetimePicker,

      InfiniteLoading,
      Treeselect,
    },
    watch: {
      user_model: function () {
        var self = this
        console.log("users_items",self.users_items)
        this.users_items.forEach(function (number) {
          if (self.user_model == number.UserName) {
            self.selected_users_items.push(number)
          }
        })
      },
      selected_category: function (val) {
        this.selected_request = null
        this.selected_user = null
      }
    },
    mounted() {

    },

    methods: {
      select_search_user(node){
        this.selected_users_items.push(node)

      },
      load_users ({ action, searchQuery, callback }) {
        this.model_txt = searchQuery
        var self = this
        if (action === ASYNC_SEARCH) {
          simulateAsyncOperation(() => {
            let options
            this.isLoading = true
            var user_id = JSON.parse(localStorage.getItem('profile')).UserId

            var self = this
            const send_data = {
              Txt: searchQuery,
              UserId: user_id,
            }
            this.axios.post('/GetUsersByTxt', send_data, {})
              .then(response => {
                // self.search_entries = response.data.Payks
                options = response.data.Payks
                callback(null, options)
                // this.$router.push({ path: "/post-login", params: {} });
              }).catch(e => {
              this.errors.push(e)
            })
          })
        }
      },

      save() {
        this.isLoading = true
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        var users =[];
        this.selected_users_items.forEach(function (val) {
          users.push(val.Id);
        });
        var self = this
        const send_data = {
          UserId: user_id,
          ReqId:0,
          Receivers:JSON.stringify(users),
          Summary:this.summary,
          ReminderTime:this.start_time,
          ReminderDate:this.start_date,
        }
        if(this.necessary){
          send_data.Essential=1
        }else{
          send_data.Essential=0
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/SetReminder', send_data, {show_pros: false})
          .then(response => {
            bus.$emit('show_toast', [3000, response.data.msg])
if(response.data.error==0){
  self.$router.go(-1)
}
            // self.count = count
            // self.entries=[];
            // self.users_items= response.data.Payks
            // self.users_items.forEach(function (number) {
            //   // var obj = {label: number.BranchName, value: number.Id}
            //   self.entries.push(number.UserName)
            // })
            // UserName
            self.isLoading = false
          }).catch(e => {
          this.errors.push(e)
        })
      },

      goToReminder() {
        this.$router.push({name: 'AddReminder', params: {}})
      },
      get_tab_style(index) {
        if (index == this.active_tab) {
          return 'width: 100%;padding: 0px;margin:0px;border-radius: 0px;background-color:blue!important'

        } else {
          return 'width: 100%;padding: 0px;margin:0px;border-radius: 0px;background-color:white!important;color:black!important'

        }
      },
      set_active_tab(index) {
        this.active_tab = index;
      },

      open_image(img) {
        window.open(img, '_blank')
      },
      goToDetail(item, is_parent) {
        if (this.disable_click) {
          return;
        }
        console.log("go to detail worked", item)
        if (is_parent == 1 && item.related_products != null && item.related_products.length == 0) {
          this.selected_product_info = item;
          this.product_info_dialog = true;
        }
        if (is_parent == 0) {
          this.selected_product_info = item;
          this.product_info_dialog = true;

        }

      },
      long_click(item) {
        var self = this;
        if (item.selected == null) {
          item.selected = true
          console.log("long click worked")

        } else {
          item.selected = null
        }
        this.disable_click = true
        setTimeout(function () {
          self.disable_click = false

        }, 1000)

        if (this.request_items.filter(x => x.selected == true).length > 0) {
          this.enable_finalize = true;
        } else {
          this.enable_finalize = false;

        }
        this.$forceUpdate()
      },
      card_style(item) {
        if (item.selected) {
          return "blue";

        } else {
          return "";

        }
      },
      go_to_finalize() {
        var array = this.request_items.filter(x => x.selected == true);
        console.log(array);
        localStorage.setItem('buy_orders_finalize', JSON.stringify(array));
        this.$router.push({name: 'BuyOrdersFinalize'})
      }
    }
  }
</script>
<style>
  .v-application .headline {
    font-size: 1rem !important;
    font-weight: 400;
    line-height: 2rem;
    letter-spacing: normal !important;
    font-family: "IRANSans" !important;
  }
</style>
